import { Controller } from "@hotwired/stimulus"

import Swal from 'sweetalert2';

import { PHOTO_CAPTURE_SHOW_MODAL, PHOTO_CAPTURE_CLOSE_MODAL, PHOTO_CAPTURE_CONFIRM_BUTTON_PRESSED_EVENT } from "../../../javascript/components/photo-capture";

export default class extends Controller {
  connect() {
    document.addEventListener(PHOTO_CAPTURE_CONFIRM_BUTTON_PRESSED_EVENT, this.confirmarEnvioChefe)

    this.element.addEventListener('submit', this.exibirOverlay);

  }

  disconnect() {
    document.removeEventListener(PHOTO_CAPTURE_CONFIRM_BUTTON_PRESSED_EVENT, this.confirmarEnvioChefe)

    this.element.removeEventListener('submit', this.exibirOverlay);

  }

  exibirOverlay = () => {
    const overlay = document.getElementById('overlay-salvando');
    if (overlay) {
      overlay.style.display = 'flex';
    }
  }


  async onSalvarEnviarClicked(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const exigeFotoEnviarRelatorio = document.getElementById('exige_foto_enviar_relatorio')?.value == 'true';

    if (exigeFotoEnviarRelatorio) {
      const customEvent = new CustomEvent(PHOTO_CAPTURE_SHOW_MODAL)
      document.dispatchEvent(customEvent);
    } else {
      this.confirmarEnvioChefe();
    }
  }

  async fecharModalFoto() {
    const customEvent = new CustomEvent(PHOTO_CAPTURE_CLOSE_MODAL)
    document.dispatchEvent(customEvent);
  }

  toggleDetalhes(e) {
    const atividadeId = e.target.dataset.value;
    const descricaoAtividadeElem = document.getElementById(atividadeId);
    if (descricaoAtividadeElem) {
      if (descricaoAtividadeElem.style.display === 'none' || getComputedStyle(descricaoAtividadeElem).display === 'none') {
        descricaoAtividadeElem.style.display = 'inline';
      } else {
        descricaoAtividadeElem.style.display = 'none';
      }
    }
  }

  async confirmarEnvioChefe() {
    const form = document.getElementById('form-relatorio')

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const result = await Swal.fire({
      title: 'Atenção!',
      text: 'Tem certeza de que deseja enviar o relatório para a conferência da chefia? \n\nVocê não poderá mais modificar o relatório.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      backdrop: true,
      focusCancel: true,
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'salvar_e_enviar';
      hiddenInput.value = 'true';
      form.appendChild(hiddenInput);

      document.getElementById('overlay-salvando')?.style.setProperty('display', 'flex');

      form.submit();
    }

  }
}